module.exports = __webpack_public_path__ + "files/48c8f23473c7c447355cc1a517622277.png";